export default {
  namespaced: true,
  state: {
    quizAnswer: {}
  },
  actions: {
    storeTestAnswers ({ state }, data) {
      state.quizAnswer[data.testRecordId] = data
    }
  },
  getters: {
    /**
     * @description 获取用户信息
     */
    quizAnswer: state => state.quizAnswer
  }
}
